// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as BigJs from "big.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as ToggleButtonGroup from "../../resources/actions/ToggleButtonGroup.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CartDiscount__Utils from "./CartDiscount__Utils.res.js";
import * as InputOptionalNumberField from "../../resources/selection-and-input/InputOptionalNumberField.res.js";

let defaultDiscount_quantity = BigJs.Big(0);

let defaultDiscount_warnings = [];

let defaultDiscount = {
  name: "",
  kind: "Percent",
  value: 0,
  quantity: defaultDiscount_quantity,
  id: "",
  formattedValue: undefined,
  amount: undefined,
  formattedAmount: undefined,
  warnings: defaultDiscount_warnings
};

function CartGlobalDiscountView(props) {
  let dispatch = props.onRequestDispatch;
  let totalAmountExcludingGlobalDiscounts = props.totalAmountExcludingGlobalDiscounts;
  let __discount = props.discount;
  let discount = __discount !== undefined ? __discount : defaultDiscount;
  let match = React.useState(() => discount.value);
  let setValue = match[1];
  let value = match[0];
  let match$1 = React.useState(() => discount.kind);
  let setKind = match$1[1];
  let kind = match$1[0];
  ReactUpdateEffect.use1(() => {
    setValue(param => discount.value);
    if (discount.id !== "") {
      setKind(param => discount.kind);
    }
  }, [discount]);
  ReactUpdateEffect.use2(() => {
    let match = discount.id;
    let exit = 0;
    if (match !== "" || value !== 0) {
      exit = 1;
    }
    if (exit === 1 && (value !== discount.value || kind !== discount.kind)) {
      if (match === "") {
        dispatch({
          TAG: "GlobalDiscountAdded",
          _0: {
            id: undefined,
            name: "",
            kind: kind,
            value: value,
            quantity: 0
          }
        });
      } else if (value !== 0) {
        let tmp;
        let exit$1 = 0;
        switch (kind) {
          case "Currency" :
            tmp = {
              name: discount.name,
              kind: kind,
              value: value,
              quantity: discount.quantity,
              id: discount.id,
              formattedValue: discount.formattedValue,
              amount: discount.amount,
              formattedAmount: discount.formattedAmount,
              warnings: discount.warnings
            };
            break;
          case "Percent" :
            if (value <= 100) {
              tmp = {
                name: discount.name,
                kind: kind,
                value: value,
                quantity: discount.quantity,
                id: discount.id,
                formattedValue: discount.formattedValue,
                amount: discount.amount,
                formattedAmount: discount.formattedAmount,
                warnings: discount.warnings
              };
            } else {
              exit$1 = 2;
            }
            break;
          case "Free" :
            exit$1 = 2;
            break;
        }
        if (exit$1 === 2) {
          tmp = {
            name: discount.name,
            kind: kind,
            value: 0,
            quantity: discount.quantity,
            id: discount.id,
            formattedValue: discount.formattedValue,
            amount: discount.amount,
            formattedAmount: discount.formattedAmount,
            warnings: discount.warnings
          };
        }
        dispatch({
          TAG: "GlobalDiscountUpdated",
          _0: discount.id,
          _1: tmp
        });
      } else {
        dispatch({
          TAG: "GlobalDiscountRemoved",
          _0: discount.id
        });
      }
    }
  }, [
    value,
    kind
  ]);
  let tmp;
  let exit = 0;
  switch (kind) {
    case "Currency" :
    case "Percent" :
      exit = 1;
      break;
    case "Free" :
      tmp = null;
      break;
  }
  if (exit === 1) {
    let match$2 = discount.warnings;
    let tmp$1;
    if (match$2.length !== 1) {
      tmp$1 = null;
    } else {
      let warning = match$2[0];
      tmp$1 = JsxRuntime.jsx(TextStyle.make, {
        children: I18n.template(CartDiscount__Utils.discountWarningToText(warning), {
          max: Stdlib_Option.map(totalAmountExcludingGlobalDiscounts, value => I18n.currencyFormat(undefined, "EUR", 3, 3, value.toNumber()))
        }, undefined),
        size: "xsmall"
      });
    }
    tmp = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(InputOptionalNumberField.make, {
            value: value,
            minValue: 0,
            maxValue: kind === "Percent" ? 100 : Stdlib_Option.mapOr(totalAmountExcludingGlobalDiscounts, 0, prim => prim.toNumber()),
            precision: 3,
            label: I18n.t("Global merchandise discount"),
            appender: kind === "Percent" ? "Percent" : ({
                TAG: "Currency",
                _0: "EUR"
              }),
            onChange: value => setValue(param => Stdlib_Option.getOr(value, 0))
          }),
          tmp$1
        ],
        space: "xsmall"
      }),
      style: {
        width: "207px"
      }
    });
  }
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      tmp,
      JsxRuntime.jsx(ToggleButtonGroup.make, {
        label: I18n.t("Type"),
        items: [
          {
            key: "percent",
            value: "Percent",
            icon: "percent"
          },
          {
            key: "currency",
            value: "Currency",
            icon: "currency"
          }
        ],
        value: {
          TAG: "Single",
          _0: kind
        },
        onChange: selection => {
          if (typeof selection !== "object") {
            return;
          }
          if (selection.TAG !== "Single") {
            return;
          }
          let kind = selection._0;
          setKind(param => kind);
        }
      })
    ],
    space: "medium"
  });
}

let make = React.memo(CartGlobalDiscountView, (oldProps, newProps) => {
  if (oldProps.discount === newProps.discount) {
    return oldProps.totalAmountExcludingGlobalDiscounts === newProps.totalAmountExcludingGlobalDiscounts;
  } else {
    return false;
  }
});

let Utils;

export {
  Utils,
  defaultDiscount,
  make,
}
/* defaultDiscount Not a pure module */
